import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userManager } from '../services/auth/oidcConfig';

const Callback: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Process the callback from OIDC provider
        const user = await userManager.signinRedirectCallback();
        
        if (user) {
          // Redirect to dashboard after successful authentication
          navigate('/dashboard', { replace: true });
        } else {
          setError('No user information received');
        }
      } catch (err) {
        console.error('Callback error:', err);
        setError('Authentication failed. Please try again.');
        
        // Redirect to home page after a delay
        setTimeout(() => {
          navigate('/', { replace: true });
        }, 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  if (error) {
    return (
      <div className="callback-page callback-page--error">
        <div className="callback-content">
          <h2>Authentication Error</h2>
          <p>{error}</p>
          <p>Redirecting to home page...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="callback-page">
      <div className="callback-content">
        <div className="callback-spinner" />
        <h2>Completing sign in...</h2>
        <p>Please wait while we redirect you to your dashboard.</p>
      </div>
    </div>
  );
};

export default Callback;